import styled from 'styled-components';

export const NonStrechingDiv = styled.div`
  display: inline-block;
`;
